import { createContext } from 'react'

import { FetchResult } from '../../../data/fetchResult'
import { Permission } from '../data/models'

export type PermissionsContextType = {
  /**
   * General permissions for the current user and tenant/project
   */
  permissions: FetchResult<Permission[]>
  /**
   * Force refresh all permissions
   */
  refreshPermissions: () => void
  /**
   * Are permissions currently being refreshed
   */
  isRefreshing: boolean
}

const stub = (): never => {
  throw new Error(
    'You forgot to wrap your component in <PermissionsContextProvider>',
  )
}

const initialValue: PermissionsContextType = {
  permissions: {
    data: undefined,
    isLoading: false,
    error: undefined,
    mutate: stub,
  },
  refreshPermissions: stub,
  isRefreshing: false,
}

export const PermissionsContext =
  createContext<PermissionsContextType>(initialValue)
